export default __webpack_public_path__ + "static/media/p2023-4.249357a2.jpeg";